"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { usePathname, useSearchParams } from "next/navigation";
import React, { ReactNode, useEffect, useTransition } from "react";
import { RouterIndicator } from "src/components/RouterIndicator/RouterIndicator";
import { useGTMPageView } from "src/lib/gtm";
import theme from "src/styles/theme";
import "src/styles/fonts";
import "src/styles/cssDependencies";
import "client-only";

// cf. https://github.com/vercel/next.js/discussions/41934#discussioncomment-8996669
const useReportAnalytics = (reportAnalyticsFn: (url: string) => void) => {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		const url = Object.keys(searchParams).length
			? `${pathname}?${searchParams.toString()}`
			: pathname;
		reportAnalyticsFn(url);
	}, [pathname, reportAnalyticsFn, searchParams]);
};

export const App: React.FC<{
	children: ReactNode;
}> = ({ children }) => {
	const trackPageView = useGTMPageView();
	const [isPending] = useTransition();

	useReportAnalytics(trackPageView);

	return (
		<ChakraProvider theme={theme}>
			<RouterIndicator isLoading={isPending} />
			{children}
		</ChakraProvider>
	);
};

// 🔬 skip
